var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 0V16L4.68579 27.3137C7.58123 30.2091 11.5812 32 15.9995 32C24.836 32 31.9995 24.8365 31.9995 16C31.9995 7.1635 15.9995 0 15.9995 0Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 0C11.5812 0 7.58123 1.79088 4.68579 4.68625C8.61141 8.61188 10.005 10.0055 15.9995 16H31.9995C31.9995 7.1635 24.836 0 15.9995 0Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.956 16.0001L9.00198 15.081L10.0425 13.1886L7.92066 13.5945L7.65179 11.4509L6.17379 13.0274L4.69585 11.4509L4.42691 13.5945L2.3051 13.1885L3.34566 15.081L1.3916 16.0001L3.34566 16.9192L2.3051 18.8117L4.4271 18.4058L4.69579 20.5493L6.17379 18.9728L7.65179 20.5493L7.92066 18.4058L10.0424 18.8118L9.00191 16.9193L10.956 16.0001Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26736 6.26105L4.91761 7.16998L5.98292 6.83255L5.31929 7.73179L5.96954 8.64073L4.90917 8.28754L4.24561 9.18673L4.25392 8.06923L3.1936 7.71598L4.2591 7.37854L4.26736 6.26105Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26736 22.8138L4.91761 23.7227L5.98292 23.3852L5.31929 24.2845L5.96954 25.1935L4.90917 24.8403L4.24561 25.7395L4.25392 24.622L3.1936 24.2687L4.2591 23.9313L4.26736 22.8138Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 14.5374L12.8915 15.4464L11.8262 15.1088L12.4898 16.0081L11.8395 16.9171L12.8999 16.5639L13.5635 17.4631L13.5552 16.3456L14.6155 15.9924L13.55 15.6549L13.5417 14.5374Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/philippines.10fda432.svg";
export { ForwardRef as ReactComponent };